import {
  COMPLETED_VISIT_TIMEFRAME_OPTIONS,
  STANDARD_PAST_TIMEFRAME_OPTIONS,
  UPCOMING_VISIT_TIMEFRAME_OPTIONS,
} from './constants';
import {
  LastCompletedVisitFilterApiPayload,
  serializeLastCompletedVisitFilter,
  serializeVisitCountFilter,
  VisitCountFilterApiPayload,
} from './visitFilterApi';
import {
  LastCompletedVisitFilterValue,
  VisitCountFilterValue,
} from './_types';

export interface ClientListVisitFilterParams {
  completedVisitCount?: VisitCountFilterApiPayload;
  cancelledVisitCount?: VisitCountFilterApiPayload;
  noShowVisitCount?: VisitCountFilterApiPayload;
  upcomingVisitCount?: VisitCountFilterApiPayload;
  lastCompletedVisit?: LastCompletedVisitFilterApiPayload;
}

export interface ClientListFilterParamsInput {
  trainer?: string;
  status?: string;
  group?: string;
  workoutPlan?: string;
  lifecycleStage?: string | number[];
  tags?: { values?: string[]; matchAll?: boolean };
  appPlatform?: string;
  customStatus?: {
    value?: string;
    number?: string;
    start?: string;
    end?: string;
  };
  customProfileField?: { field?: string; value?: string };
  completedVisitCount?: VisitCountFilterValue | null;
  cancelledVisitCount?: VisitCountFilterValue | null;
  noShowVisitCount?: VisitCountFilterValue | null;
  upcomingVisitCount?: VisitCountFilterValue | null;
  lastCompletedVisit?: LastCompletedVisitFilterValue | null;
}

const completedTimeframeDays = COMPLETED_VISIT_TIMEFRAME_OPTIONS.map(
  (option) => option.value
);
const standardPastTimeframeDays = STANDARD_PAST_TIMEFRAME_OPTIONS.map(
  (option) => option.value
);
const upcomingTimeframeDays = UPCOMING_VISIT_TIMEFRAME_OPTIONS.map(
  (option) => option.value
);

export const buildClientListVisitFilters = (
  filterParams?: ClientListFilterParamsInput | null
): ClientListVisitFilterParams => ({
  completedVisitCount: serializeVisitCountFilter(
    filterParams?.completedVisitCount,
    completedTimeframeDays
  ),
  cancelledVisitCount: serializeVisitCountFilter(
    filterParams?.cancelledVisitCount,
    standardPastTimeframeDays
  ),
  noShowVisitCount: serializeVisitCountFilter(
    filterParams?.noShowVisitCount,
    standardPastTimeframeDays
  ),
  upcomingVisitCount: serializeVisitCountFilter(
    filterParams?.upcomingVisitCount,
    upcomingTimeframeDays
  ),
  lastCompletedVisit: serializeLastCompletedVisitFilter(
    filterParams?.lastCompletedVisit,
    standardPastTimeframeDays
  ),
});

export const clientListVisitFilterQueryParams = (
  visitFilters: ClientListVisitFilterParams
) => ({
  ...(visitFilters.completedVisitCount && {
    'q[filter_completed_visit_count]': JSON.stringify(
      visitFilters.completedVisitCount
    ),
  }),
  ...(visitFilters.cancelledVisitCount && {
    'q[filter_cancelled_visit_count]': JSON.stringify(
      visitFilters.cancelledVisitCount
    ),
  }),
  ...(visitFilters.noShowVisitCount && {
    'q[filter_no_show_visit_count]': JSON.stringify(
      visitFilters.noShowVisitCount
    ),
  }),
  ...(visitFilters.upcomingVisitCount && {
    'q[filter_upcoming_visit_count]': JSON.stringify(
      visitFilters.upcomingVisitCount
    ),
  }),
  ...(visitFilters.lastCompletedVisit && {
    'q[filter_last_completed_visit]': JSON.stringify(
      visitFilters.lastCompletedVisit
    ),
  }),
});
